(() => {
  'use strict';
  const control = document.querySelector('[data-mam-language-control]');
  if (!control || control.dataset.bound) return;
  control.dataset.bound = 'true';
  const languages = ['en', 'hi', 'te', 'ta', 'kn', 'ml', 'mr', 'bn', 'gu', 'pa'];
  const provider = control.querySelector('[data-mam-provider]');
  const status = control.querySelector('[data-mam-language-status]');
  const storageKey = 'mam_store_language';
  const languageGlyphs = { en:'अ', hi:'अ', te:'త', ta:'அ', kn:'ಕ', ml:'അ', mr:'अ', bn:'অ', gu:'અ', pa:'ਅ' };
  function syncLanguageVisuals(language) {
    for (const node of document.querySelectorAll('[data-mam-language-code]')) node.textContent=language.toUpperCase();
    for (const node of document.querySelectorAll('[data-mam-language-glyph]')) node.textContent=languageGlyphs[language]||languageGlyphs.en;
    control.dataset.currentLanguage=language;
  }
  const searchHints=Array.from(document.querySelectorAll('.mm-search input[type="search"]'),input=>({input,original:input.placeholder}));
  function syncSearchHints(){
    for(const {input,original} of searchHints){
      input.placeholder=current==='en'?original:(input.labels?.[0]?.textContent.trim()||original);
    }
  }
  let headerCopy = {};
  try { headerCopy = JSON.parse(document.querySelector('[data-mam-header-copy]')?.textContent || '{}'); } catch (_) {}
  const headerLabels = document.querySelectorAll('[data-mam-header-label]');
  function syncHeaderLabels(language) {
    const copy = headerCopy[language] || headerCopy.en;
    if (!copy) return;
    for (const label of headerLabels) {
      const text = copy[label.dataset.mamHeaderLabel];
      if (typeof text === 'string' && label.textContent !== text) label.textContent = text;
    }
  }
  let current = 'en';
  let loader;
  let request = 0;
  let forwarding = false;
  try { const saved = localStorage.getItem(storageKey); if (languages.includes(saved)) current = saved; } catch (_) {}

  const protect = root => {
    if (!(root instanceof Element || root instanceof Document)) return;
    const selectors = [
      'input', 'textarea', 'select[name="id"]', 'select[name^="options"]', '[contenteditable]', '[data-customer]',
      '.customer', '[data-customer-name]', '[data-customer-email]', '.shiprocket-login-link',
       '.mm-order-phone', '[data-mm-cart-count]',
      '.mm-product__price', '[data-mm-price]', '[data-mm-compare]',  '.mm-product__pack', '.mm-variant-trigger',  
      '.mvp-pack__price', '.mvp-pack__compare', '.mvp-pack__unit', '.mvp-pack__body>strong',
      '[data-mvp-selected]', '[data-mvp-total]', '[data-mvp-vendor]', '[data-mvp-quantity]',
      '[data-mm-variant]', '.price', '[data-mam-preserve]', 'select[data-mam-language]',
      '.variant-option__button-label', '.quantity-selector', 'quantity-selector',
      'script', 'style', 'code', 'pre'
    ].join(',');
    const nodes = root.querySelectorAll(selectors);
    for (const node of nodes) {
      node.classList.add('notranslate'); node.setAttribute('translate', 'no');
    }
    if (root instanceof Element && root.matches(selectors)) { root.classList.add('notranslate'); root.setAttribute('translate', 'no'); }
  };
  protect(document);

  function sync(language) {
    current = language;
    document.documentElement.dataset.mamStoreLanguage = language;
    document.documentElement.lang = language;
    syncSearchHints();
    syncHeaderLabels(language);
    syncLanguageVisuals(language);
    for (const select of document.querySelectorAll('select[data-mam-language]')) select.value = language;
    for (const select of provider.querySelectorAll('.gt_selector')) select.setAttribute('aria-label', control.dataset.label);
    try { localStorage.setItem(storageKey, language); } catch (_) {}
    document.dispatchEvent(new CustomEvent('mam:language-change', { detail: { language } }));
  }
  function showStatus(copy) { status.textContent = copy; status.hidden = !copy; }
  function waitForProvider() {
    return new Promise((resolve, reject) => {
      const found = () => provider.querySelector('.gt_selector');
      if (found()) { resolve(found()); return; }
      const observer = new MutationObserver(() => { const select = found(); if (select) { observer.disconnect(); clearTimeout(timer); resolve(select); } });
      const timer = setTimeout(() => { observer.disconnect(); reject(new Error('Language selector unavailable')); }, 12000);
      observer.observe(provider, { childList: true, subtree: true });
    });
  }
  function loadProvider() {
    if (provider.querySelector('.gt_selector')) return Promise.resolve(provider.querySelector('.gt_selector'));
    if (loader) return loader;
    window.gtranslateSettings = {
      default_language: 'en', languages, wrapper_selector: '.gtranslate_wrapper',
      native_language_names: true, detect_browser_language: false
    };
    loader = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = 'https://cdn.gtranslate.net/widgets/latest/dropdown.js';
      script.async = true;
      script.onload = () => waitForProvider().then(resolve, reject);
      script.onerror = () => { script.remove(); reject(new Error('Language service unavailable')); };
      document.head.append(script);
    }).catch(error => { loader = undefined; throw error; });
    return loader;
  }
  async function changeLanguage(language) {
    if (!languages.includes(language)) return;
    const revision = ++request;
    if (language === 'en' && !provider.querySelector('.gt_selector') && !loader) { sync('en'); showStatus(''); return; }
    showStatus(control.dataset.loading);
    try {
      protect(document);
      const select = await loadProvider();
      if (revision !== request) return;
      select.value = 'en|' + language;
      forwarding = true; select.dispatchEvent(new Event('change', { bubbles: true })); forwarding = false;
      sync(language); showStatus('');
    } catch (_) {
      if (revision !== request) return;
      forwarding = false;
      sync('en'); showStatus(control.dataset.error);
    }
  }
  document.addEventListener('change', event => {
    const select = event.target;
    if (!(select instanceof HTMLSelectElement) || forwarding) return;
    if (select.matches('select[data-mam-language]')) { changeLanguage(select.value); return; }
    if (select.matches('.gtranslate_wrapper .gt_selector')) {
      const language = select.value.split('|').pop();
      if (languages.includes(language)) { ++request; sync(language); showStatus(''); }
    }
  });
  const observer = new MutationObserver(records => {
    syncSearchHints();
    for (const record of records) for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      protect(node);
      if (node.matches('select[data-mam-language]')) node.value = current;
      for (const select of node.querySelectorAll('select[data-mam-language]')) select.value = current;
      for (const select of node.querySelectorAll('.gt_selector')) select.setAttribute('aria-label', control.dataset.label);
    }
  });
  observer.observe(document.body, { childList: true, characterData: true, subtree: true });
  window.addEventListener('pagehide', () => observer.disconnect());
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    observer.observe(document.body, { childList: true, characterData: true, subtree: true });
    let saved = current;
    try { saved = localStorage.getItem(storageKey) || current; } catch (_) {}
    if (languages.includes(saved) && saved !== current) changeLanguage(saved);
    else sync(current);
  });
  sync(current);
  if (current !== 'en') changeLanguage(current);
})();


